import {
    LIST_CENTERS,
    LIST_CENTERS_SUCCESS,
    LIST_CENTERS_ERROR
} from '../types';

//Cada reducer tiene su propio state
const initialState = {
    centers: null,
    error: null,
    loading: false
}

export default function centersReducer(state = initialState, action) {
    switch(action.type){
        case LIST_CENTERS:
            return {
                ...state,
                loading: true
            }
        case LIST_CENTERS_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_CENTERS_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                centers: action.payload
            }
        default:
            return state;
    }
}